import React from 'react'

const Pagination = ({ page, totalPages, setPage, totalItems, showingCount }) => {
    if (totalItems === 0) return null

    const changePage = (p) => {
        if (p > 0 && p <= totalPages) {
            setPage(p)
            window.scrollTo(0, 0)
        }
    }

    return (
        <div className='d-flex flex-column align-items-end mt-4'>
            <p className='mb-3 text-muted' style={{ fontSize: 13 }}>
                Showing {showingCount} of {totalItems} items
            </p>
            <div className='d-flex justify-content-center flex-wrap'>
                <div className='bd-number-pagination rounded-2 me-3 mt-2' onClick={() => changePage(page - 1)}>
                    <i className='icon-arrow-left'></i>
                </div>
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter(p => p >= page - 2 && p <= page + 2)
                    .map(p => (
                        <div key={p}
                            className={`bd-number-pagination rounded-2 mx-1 pe-1 mt-2 ${page === p ? 'activepage' : ''}`}
                            onClick={() => changePage(p)}>
                            {p < 10 ? '0' + p : p}
                        </div>
                    ))}
                <div className='bd-number-pagination rounded-2 ms-3 mt-2' onClick={() => changePage(page + 1)}>
                    <i className='icon-arrow-right'></i>
                </div>
            </div>
        </div>
    )
}

export const PerPageSelect = ({ itemsPerPage, setItemsPerPage, setPage }) => (
    <select className='form-select ms-3 fs-5' value={itemsPerPage}
        onChange={(e) => { setPage(1); setItemsPerPage(Number(e.target.value)) }}
        style={{ width: '110px', height: '45px', flexShrink: 0, borderRadius: '8px' }}>
        <option value={5}>Show 5</option>
        <option value={10}>Show 10</option>
        <option value={20}>Show 20</option>
        <option value={30}>Show 30</option>
    </select>
)

export default Pagination
